import React from "react";

const TermsConditions = () => {
  return (
    <div className="container">
      <h1>Allgemeine Geschäftsbedigungen (AGB)</h1>
      <h4>
        für die Nutzung der Online-Plattform und App My deserve
      </h4>
      <br />
      <h4>
        1. Anwendungs- und Geltungsbereich
      </h4>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der vom Unternehmen My deserve (nachfolgend «My deserve» genannt) betriebenen Online-Plattform («www.mydeserve.ch») sowie App («https://app.mydeserve.ch») durch registrierte Nutzerinnen und Nutzer (nachfolgend «Nutzer»).
        <br />
        <br />
        Die Plattform und die Leistungen von My deserve richten sich ausschliesslich an Personen mit Wohnsitz in der Schweiz. Für Personen mit ausländischem Wohnsitz ist die Nutzung nicht möglich.
      </p>
      <h4>
        2. Konzept von My deserve
      </h4>
      <p>
        My deserve betreibt mittels App eine Plattform zur Vermittlung zwischen Drittunternehmen, welche ihre Produkte in den sozialen Medien bewerben möchten und Nutzern, welche Gutscheine, Gratisprodukte, kostenlose Dienstleitungen und weitere Gratisangebote (nachfolgend «Gratisinhalte» genannt) gewinnen (nachfolgend «deserven» genannt) möchten. Die Drittunternehmen laden auf der Plattform einen Gratisinhalt hoch, den sie bewerben wollen. Die Nutzer können die auf der Plattform verfügbaren Gratisinhalte «deserven», wenn sie einen Gratisinhalt zum «deserven» anwählen, ihn in den sozialen Medien posten und anschliessend die von My deserve zum Voraus definierte Anzahl «Likes» für ihren Post innert einer vordefinierten Frist erhalten. 
        <br />
        <br />
        Die Teilnahmebedingungen für den jeweiligen Gratisinhalt werden von My deserve auf der Plattform veröffentlicht.
      </p>
      <h4>
        3. Registrierung und Benutzerkonto
      </h4>
      <p>
        Für die Nutzung der Plattform ist eine Registrierung erforderlich. Die Nutzer müssen sich mit einer gültigen E-Mail-Adresse registrieren und ein Benutzerkonto erstellen.
        <br />
        <br />
        Die Nutzer sind dafür verantwortlich, dass die von ihnen bereitgestellten Informationen wahrheitsgemäss, vollständig und aktuell sind.
        <br />
        <br />
        Die Nutzer sind verpflichtet, ihre Zugangsdaten vertraulich zu behandeln und den Zugang zur Plattform vor dem Zugriff Dritter zu schützen.
        <br />
        <br />
        Nutzer können ihr Konto jederzeit ohne Angabe von Gründen kündigen, indem sie My deserve schriftlich oder über die entsprechenden Funktionen der Plattform benachrichtigen.
      </p>
      <h4>
        4. Verpflichtungen der Nutzer
      </h4>
      <p>
        Die Nutzer verpflichten sich, die Plattform ordnungsgemäss zu nutzen, sich an das geltende Schweizer Recht zu halten und keine Inhalte zu veröffentlichen, die gegen geltendes Recht verstossen oder unangemessen sowie irreführend sind. Insbesondere verpflichten sich die Nutzer, die beworbenen Unternehmen fair darzustellen und nur ehrliche Empfehlungen auszusprechen. Darüber hinaus ist es erforderlich, dass die Veröffentlichungen der Nutzer für alle Personen zugänglich sind, um eine transparente Überprüfung der gesammelten Likes zu ermöglichen. Zum Beispiel müssen Facebook-Posts die Privatsphäre-Einstellung "Öffentlich" haben.
        <br />
        <br />
        Die Nutzer sind dafür verantwortlich, die erforderlichen Likes und Interaktionen auf natürliche Weise und ohne den Einsatz unlauterer Mittel (wie z.B. den Kauf von Likes, automatisierten Bots oder andere manipulative Techniken) zu sammeln. Der Einsatz solcher unrechtmässiger Methoden führt zum sofortigen Ausschluss von der Plattform und zur Verwirkung aller Ansprüche auf Gratisinhalte.
        <br />
        <br />
        My deserve behält sich das Recht vor, Massnahmen zu ergreifen, um die Einhaltung dieser Verpflichtungen zu überprüfen. Bei Verstössen, wie z.B. durch den Einsatz unzulässiger Mittel, können Nutzerkonten gesperrt und bereits erhaltene Gegenleistungen aberkannt werden.
      </p>
      
      <h4>
        5. Teilnahme an Wettbewerben
      </h4>
      <p>
        Auf der Plattform von My deserve ist ersichtlich, welche Gratisinhalte zum «deserven» zur Verfügung stehen. Die Möglichkeit, ein auf der Plattform von My deserve zur Verfügung stehender Gratisinhalt zu «deserven» besteht erst, wenn nach dem Anwählen des Gratisinhalts eine Bestätigung durch My deserve erfolgt ist.
        <br />
        <br />
        Nutzer können auf der Plattform ausgeschriebene Gratisinhalte «deserven», indem sie die in Bezug auf den konkreten Gratisinhalt auf der Plattform angegebenen Bedingungen erfüllen (Teilen eines Beitrags auf sozialen Medien und Erreichen einer bestimmten Anzahl von Likes innert der angegebenen Frist).
        <br />
        <br />
        Die Bedingungen, insbesondere die erforderliche Anzahl von Likes sowie die Frist zum Sammeln der Likes, werden von My deserve vorgegeben und sind verbindlich. 
        <br />
        <br />
        My deserve prüft nach Ablauf der Frist, ob die Teilnahmebedingungen erfüllt wurden, und entscheidet über die Vergabe des Gratisinhalts.
        <br />
        <br />
        Ein «deservter» Gratisinhalt ist grundsätzlich innerhalb von sechs Monaten ab Erhalt der Bestätigung von My deserve, dass der entsprechende Gratisinhalt «deservt» wurde, zu beziehen. Nach Ablauf dieser sechsmonatigen Frist entfällt der Anspruch auf den Gratisinhalt. Vorbehalten sind auf der Plattform von My deserve in Bezug auf einen bestimmten Gratisinhalt angegebene abweichende Fristen. Die abweichenden Fristen können länger als sechs Monate sein, nicht aber kürzer.
      </p>
      <h4>
        6. Leistungen von My deserve
      </h4>
      <p>
        My deserve stellt die technische Plattform zur Verfügung, auf der Wettbewerbe durchgeführt werden können.
        <br />
        <br />
        My deserve übernimmt die Prüfung der Erfüllung der Teilnahmebedingungen.
        <br />
        <br />
        Die Tätigkeit von My deserve besteht darüber hinaus ausschliesslich in der Vermittlung zwischen den Drittunternehmen und den Nutzern. Wenn die Bedingungen zum «deserven» eines Gratisinhalts erfüllt wurden, besteht ausschliesslich gegenüber den Drittunternehmen ein Anspruch.
        <br />
        <br />
        Eine Barauszahlung der erhaltenen Gratisinhalte ist nicht möglich. Die Verantwortung für die Bereitstellung und Übergabe der Gratisinhalte liegt ausschliesslich beim jeweiligen Anbieter.
        <br />
        <br />
        Für die Inhalte der durch Drittunternehmen beworbenen Gratisinhalte übernimmt My deserve keine Haftung.
      </p>
      <h4>
        7. Unentgeltlichkeit
      </h4>
      <p>
        Die Nutzung der Plattform ist für Nutzer kostenlos.
        <br />
        <br />
        Etwaige Kosten für Drittunternehmen werden separat vertraglich geregelt.
      </p>
      <h4>
        8. Datenschutz
      </h4>
      <p>
        Die Bearbeitung personenbezogener Daten erfolgt gemäss der Datenschutzerklärung von My deserve («https://app.mydeserve.ch/privacy-policy»). Die Datenschutzerklärung ist integraler Bestandteil dieser AGB.
      </p>
      <h4>
        9. Haftungsausschluss
      </h4>
      <p>
        My deserve übernimmt – Vorsatz und Grobfahrlässigkeit vorbehalten – keine Haftung für direkte oder indirekte Schäden, die durch die Nutzung der Plattform oder durch die Inanspruchnahme der angebotenen Dienstleistungen entstehen. My deserve haftet auch nicht für die Qualität oder Verfügbarkeit der von den Unternehmen angebotenen Produkte oder Dienstleistungen.
        <br />
        <br />
        Für die Richtigkeit und Verfügbarkeit von Social-Media-Plattformen sowie die Erreichbarkeit der Inhalte übernimmt My deserve keine Haftung.
      </p>
      <h4>
        10. Nutzungsrechte an Inhalten
      </h4>
      <p>
        Mit der Nutzung der Plattform und dem Veröffentlichen von Inhalten, wie Posts oder Bewertungen auf sozialen Medien, räumen die Nutzer My deserve ein einfaches, zeitlich unbegrenztes und kostenloses Nutzungsrecht an diesen Inhalten ein. Dies umfasst das Recht zur Vervielfältigung, Verbreitung, Veröffentlichung und Darstellung der Inhalte im Zusammenhang mit der Plattform.
      </p>
      <h4>
        11. Missbrauch und Sanktionen
      </h4>
      <p>
        My deserve behält sich das Recht vor, bei Verstößen gegen diese AGB oder andere geltende Vorschriften das Nutzerkonto vorübergehend oder dauerhaft zu sperren. In schwerwiegenden Fällen, wie z.B. bei Täuschungsversuchen, Missbrauch der Plattform oder der Verbreitung rechtswidriger Inhalte, kann der Nutzer dauerhaft von der Nutzung ausgeschlossen werden. Bereits verdiente Gratisinhalte verfallen in diesem Fall.
      </p>
      <h4>
        12. Technische Verfügbarkeit und Wartung
      </h4>
      <p>
        My deserve ist bemüht, die Plattform durchgehend verfügbar zu halten. Es kann jedoch keine Gewähr für eine unterbrechungsfreie Nutzung der Plattform abgegeben werden. Geplante Wartungsarbeiten werden soweit möglich, rechtzeitig angekündigt. My deserve haftet nicht für Ausfallzeiten oder technische Probleme, die durch Dritte verursacht werden.
      </p>
      <h4>
        13. Abtretung und Übertragung
      </h4>
      <p>
        Nutzer sind nicht berechtigt, ihre Rechte oder Pflichten aus der Nutzung der Plattform und Leistungen von My deserve ohne vorherige schriftliche Zustimmung von My deserve auf Dritte zu übertragen. My deserve behält sich das Recht vor, seine Rechte und Pflichten aus diesen AGB auf ein verbundenes Unternehmen oder einen Dritten zu übertragen.
      </p>
      <h4>
        14. Änderung der AGB
      </h4>
      <p>
        My deserve behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden den Nutzern in geeigneter Form mitgeteilt. Die weitere Nutzung der Plattform nach Inkrafttreten gilt als Zustimmung.
      </p>
      <h4>
        15. Anwendbares Recht und Gerichtsstand
      </h4>
      <p>
        Es gilt ausschliesslich materielles Schweizer Recht. Ausschliesslicher Gerichtsstand ist 8001 Zürich.
      </p>
    </div>
  );
};

export default TermsConditions;
